import BrowserStorage from './BrowserStorage';

export default class TableColumnStorage<DefaultValues = string[]>
  extends BrowserStorage<DefaultValues> {
  constructor(key: string, defaultValues: DefaultValues) {
    super(key, defaultValues, 'table-columns-');
  }
}
